import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { TrendingUpIcon, ArrowRightIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../../data/productImages';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
export function TrendingProducts() {
  const [searchParams] = useSearchParams();
  const isNowContext = searchParams.get('from') === 'now';
  const {
    scrollContainerRef,
    isMobile,
    handleScroll
  } = useHorizontalScroll();
  const products = [{
    id: 1,
    name: 'Retinol Serum 2.5%',
    brand: 'The Ordinary',
    price: 34.99,
    originalPrice: 49.99,
    discount: 30,
    rating: 4.9,
    reviewCount: 2456,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 2,
    name: 'Hyaluronic Acid Serum',
    brand: 'CeraVe',
    price: 44.99,
    rating: 4.8,
    reviewCount: 1823,
    image: PRODUCT_IMAGES[1],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }, {
    id: 3,
    name: 'Vitamin C Brightening Serum',
    brand: 'La Roche-Posay',
    price: 39.99,
    originalPrice: 59.99,
    discount: 33,
    rating: 4.7,
    reviewCount: 3102,
    image: PRODUCT_IMAGES[2],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 4,
    name: 'Niacinamide 10% + Zinc 1%',
    brand: 'The Ordinary',
    price: 24.99,
    originalPrice: 34.99,
    discount: 29,
    rating: 4.6,
    reviewCount: 1567,
    image: PRODUCT_IMAGES[3],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 5,
    name: 'Moisturizing Cream',
    brand: 'Neutrogena',
    price: 19.99,
    originalPrice: 29.99,
    discount: 33,
    rating: 4.5,
    reviewCount: 2234,
    image: PRODUCT_IMAGES[4],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 6,
    name: 'Sunscreen SPF 50+',
    brand: 'Bioderma',
    price: 32.99,
    originalPrice: 44.99,
    discount: 27,
    rating: 4.8,
    reviewCount: 1890,
    image: PRODUCT_IMAGES[0],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }];
  return <div className="w-full" data-id="element-2034" data-mp="23mnjox43st6t">
      <div className="container mx-auto px-4" data-id="element-2035" data-mp="23me0bsdkdka3">
        <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl overflow-hidden mb-6" data-id="element-2036" data-mp="28l73aqv85sw0">
          <div className="p-6 md:p-8" data-id="element-2037" data-mp="1twkrgz4t3j9j">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-2038" data-mp="1tvj2rruvay9c">
              <div className="mb-4 md:mb-0" data-id="element-2039" data-mp="1yt1fzufx3zn5">
                <span className="text-xs font-bold text-white bg-white bg-opacity-20 px-2 py-0.5 rounded-full mb-2 inline-block uppercase" data-id="element-2040" data-mp="2mjyg89ycp8ik">
                  WHAT'S HOT
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-white flex items-center" data-id="element-2041" data-mp="fvy3slxluq0b">
                  <TrendingUpIcon className="w-6 h-6 md:w-8 md:h-8 mr-2" data-id="element-2042" data-mp="ax4s8z1vp92s" />
                  Trending Now
                </h2>
              </div>
              <a href="#" className="text-white bg-white bg-opacity-20 hover:bg-opacity-30 px-4 py-2 rounded-full text-sm font-medium transition-colors flex items-center" data-id="element-2043" data-mp="on86p3uinyho">
                View All
                <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-2044" data-mp="3o3mwqj8okze8" />
              </a>
            </div>
          </div>
        </div>
        {/* Mobile Slider */}
        {isMobile ? <div className="relative -mx-4" data-id="element-2045" data-mp="5zbla3sr4b1g">
            <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3 px-4 pb-4" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-2046" data-mp="yfi5sg84sx3">
              {products.map((product, idx) => <motion.div key={product.id} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05,
            duration: 0.4
          }} className={`snap-start flex-shrink-0 ${isNowContext ? 'w-[calc((100vw-32px)/3)] max-w-[150px]' : 'w-[42vw] max-w-[200px]'}`} data-id="element-2047" data-mp="2co53lyhciv74" data-mpi={idx}>
                  <EnhancedProductCard product={product} data-id="element-2048" data-mp="3ab428erlmd7n" />
                </motion.div>)}
            </div>
          </div> :
      // Desktop Grid
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-2049" data-mp="3eamqnkimp6f8">
            {products.map((product, idx) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05,
          duration: 0.4
        }} data-id="element-2050" data-mp="yn90usqn1f6z" data-mpi={idx}>
                <EnhancedProductCard product={product} data-id="element-2051" data-mp="1cnjug3jc17vu" />
              </motion.div>)}
          </div>}
      </div>
    </div>;
}